import React, { useEffect, useState } from "react";
import "./Campaigns.css";
import config from "../../../../config";

const CAMPAIGN_TYPES = [
  "SALE",
  "NEW_ARRIVAL",
  "CLEARANCE",
  "SEASONAL",
  "FLASH_SALE",
  "CUSTOM",
];

const CAMPAIGN_STATUS = [
  "ACTIVE",
  "INACTIVE",
];

export default function CreateCampaignModal({
  campaign,
  onClose,
  onSuccess,
}) {

  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    name: "",
    description: "",
    campaignType: "SALE",
    status: "ACTIVE",

    startDate: "",
    startTime: "00:00",

    endDate: "",
    endTime: "23:59",

    couponEnabled: false,
    couponCode: "",
  });

  useEffect(() => {

    if (!campaign) return;

    setForm({
      name: campaign.name || "",
      description: campaign.description || "",
      campaignType: campaign.campaignType || "SALE",
      status: campaign.status || "ACTIVE",
      startDate: campaign.startDate
        ? campaign.startDate.substring(0, 10)
        : "",

      startTime: campaign.startDate
        ? campaign.startDate.substring(11, 16)
        : "00:00",

      endDate: campaign.endDate
        ? campaign.endDate.substring(0, 10)
        : "",

      endTime: campaign.endDate
        ? campaign.endDate.substring(11, 16)
        : "23:59",
      couponEnabled: campaign.couponEnabled || false,
      couponCode: campaign.couponCode || "",
    });

  }, [campaign]);

  const handleChange = (field, value) => {
    setForm(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {

    if (!form.name.trim()) {
      alert("Campaign Name is required.");
      return;
    }

    try {

      setSaving(true);

      const payload = {
        ...form,

        startDate: form.startDate
          ? `${form.startDate}T${form.startTime}:00`
          : null,

        endDate: form.endDate
          ? `${form.endDate}T${form.endTime}:00`
          : null,
      };

      const url = campaign
        ? `${config.baseUrl}/admin/campaigns/${campaign.id}`
        : `${config.baseUrl}/admin/campaigns`;

      const method = campaign ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to save campaign");
      }

      const savedCampaign = await response.json();

      alert(
        campaign
          ? "Campaign updated successfully."
          : "Campaign created successfully."
      );

      onSuccess(savedCampaign);

    } catch (err) {
      console.error(err);
      alert(err.message);
    } finally {
      setSaving(false);
    }

  };

  return (

    <div className="modal-overlay">

      <div className="modal-content">

        <div className="modal-header">

          <h2>

            {campaign
              ? "Edit Campaign"
              : "Create Campaign"}

          </h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            ×
          </button>

        </div>

        <div className="modal-body">

          <div className="payload-box">

            <h3>Campaign Information</h3>

            <div className="form-grid">

              <div className="form-group">
                <label>Campaign Name *</label>

                <input
                  value={form.name}
                  onChange={(e) =>
                    handleChange("name", e.target.value)
                  }
                />
              </div>

              <div className="form-group">

                <label>Campaign Type</label>

                <select
                  value={form.campaignType}
                  onChange={(e) =>
                    handleChange("campaignType", e.target.value)
                  }
                >

                  {CAMPAIGN_TYPES.map(type => (

                    <option
                      key={type}
                      value={type}
                    >
                      {type}
                    </option>

                  ))}

                </select>

              </div>

              <div className="form-group">

                <label>Status</label>

                <select
                  value={form.status}
                  onChange={(e) =>
                    handleChange("status", e.target.value)
                  }
                >

                  {CAMPAIGN_STATUS.map(status => (

                    <option
                      key={status}
                      value={status}
                    >
                      {status}
                    </option>

                  ))}

                </select>

              </div>

              <div className="form-group">

                <label>Start Date</label>

                <input
                  type="date"
                  value={form.startDate}
                  onChange={(e) =>
                    handleChange("startDate", e.target.value)
                  }
                />

              </div>

              <div className="form-group">
                <div className="form-group">

                  <label>Start Time</label>

                  <input
                    type="time"
                    value={form.startTime}
                    onChange={(e) =>
                      handleChange("startTime", e.target.value)
                    }
                  />

                </div>

                <label>End Date</label>

                <input
                  type="date"
                  value={form.endDate}
                  onChange={(e) =>
                    handleChange("endDate", e.target.value)
                  }
                />

              </div>

            </div>
            <div className="form-group">

              <label>End Time</label>

              <input
                type="time"
                value={form.endTime}
                onChange={(e) =>
                  handleChange("endTime", e.target.value)
                }
              />

            </div>

            <div className="form-group">

              <label>Description</label>

              <textarea
                rows={4}
                value={form.description}
                onChange={(e) =>
                  handleChange("description", e.target.value)
                }
              />

            </div>

          </div>

          <div className="payload-box">

            <h3>Coupon</h3>

            <label className="checkbox-label">

              <input
                type="checkbox"
                checked={form.couponEnabled}
                onChange={(e) =>
                  handleChange("couponEnabled", e.target.checked)
                }
              />

              Enable Coupon

            </label>

            {form.couponEnabled && (

              <div className="form-group">

                <label>Coupon Code</label>

                <input
                  value={form.couponCode}
                  onChange={(e) =>
                    handleChange("couponCode", e.target.value)
                  }
                />

              </div>

            )}

          </div>

        </div>

        <div className="modal-actions">

          <button onClick={onClose}>
            Cancel
          </button>

          <button
            className="btn-primary"
            disabled={saving}
            onClick={handleSave}
          >
            {saving
              ? "Saving..."
              : campaign
                ? "Update Campaign"
                : "Create Campaign"}
          </button>

        </div>

      </div>

    </div>

  );

}